// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";

type PropsType = {
  translate: string => void
};

type StateType = {};

class PartnerLeadGeneratorUnit extends Component<PropsType, StateType> {
  render() {
    const { translate } = this.props;
    return (
      <section className="section py-7 landing-page-partner-lead-area">
        <div className="container">
          <div className="row gap-y align-items-center">
            <div className="col-md-9">
              <h4 className="mb-0 text-white text-center text-md-left">
                {translate("LandingPageLocale.partner_lead_generator_unit.lead")}
              </h4>
            </div>

            <div className="col-md-3 text-center text-md-right">
              <Link to="/kayit-ol" className="btn btn-lg btn-round btn-light">
                {translate("LandingPageLocale.partner_lead_generator_unit.action")}
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default PartnerLeadGeneratorUnit;



// WEBPACK FOOTER //
// ./src/Components/PublicPages/Components/LandingPage/PartnerLeadGeneratorUnit.js